module.exports = __webpack_public_path__ + "static/media/premium@2x.593c8615.png";